import React from 'react'

export default function PlanCardSkeleton() {
  return (
    <div className='flex flex-col rounded-lg overflow-hidden bg-white border border-neutral-200 animate-pulse'>

      <div className='px-6 mt-10 space-y-4'>
        <div className='h-6 bg-neutral-200 rounded w-full' />
        <div className='h-6 bg-neutral-200 rounded w-full' />

        <div className='space-y-2 pt-2'>
          <div className='h-2 bg-neutral-200 rounded w-full' />
          <div className='h-2 bg-neutral-200 rounded w-1/2' />
        </div>

        <div className='space-y-2'>
          <div className='h-2 bg-neutral-200 rounded w-full' />
          <div className='h-2 bg-neutral-200 rounded w-1/2' />
        </div>
      </div>

      <div className='px-6 pt-6 space-y-4'>
        <div className='h-12 bg-neutral-200 rounded-lg w-full' />
        <div className='h-12 bg-neutral-200 rounded-lg w-full' />
      </div>

      <div className='border-t border-neutral-200 my-8 mx-6' />

      <div className='px-6 flex-1 space-y-4 pb-6'>
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className='space-y-2'>
            <div className='h-2 bg-neutral-200 rounded w-full' />
            <div className='h-2 bg-neutral-200 rounded w-1/2' />
          </div>
        ))}
      </div>
    </div>
  )
}
